import React, { useEffect, useState, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import "../include/css/bootstrap.min.css";
import "../include/css/style.css";
import "../include/css/dev.css";
import algoliasearch from "algoliasearch";
import _ from "lodash";
import Slider from "react-slick";

import { navigate } from "gatsby";
import queryString from "query-string";

//  Components
import PipeFilterSidebar from "../components/pipeFilterSidebar";
import Footer from "../components/common/footer";
import PipeFilterSidebarMobile from "../components/pipeFilterSidebarMobile";
// import SEO from "../components/seo";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import AskQuestionModal from "../components/askQuestionModal";
import { showPipeLogo } from "../actions/dashboardAction";
import { toast } from "react-toastify";
import AlertSuccess from "../components/common/alertSuccess";
import AlertError from "../components/common/alertError";
import { parse } from "query-string";
import ImageLargeModal from "../components/common/imageLargeModal";
import { updatePipeLog } from "../actions/memberAction";
import { SEO } from "../components/seo";
import { imageUrl } from "../actions/miscAction";
import InfiniteScroll from "react-infinite-scroller";
import { isMobile } from "react-device-detect";
import Header from "../components/newDesign/header/header";

const emptyIcon = imageUrl("list.svg");

const listCarretIcon = process.env.GATSBY_IMAGE_URL + "list-carret-icon.svg";

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);
const App = (props) => {
  const productSlider = {
    variableWidth: true,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,

          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,

          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,

          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  const ref = useRef(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showFilterMobileModal, setShowFilterMobileModal] = useState(false);
  const [filterModalData, setFilterModalData] = useState([]);
  const [filterModalDataCounts, setFilterModalDataCounts] = useState([]);
  const [modalType, setModalType] = useState("");
  const [facets, setFacets] = useState({});
  //pipe
  const [tab, setTab] = useState(1);
  const [catagory, setCategory] = useState(["pipe"]);
  const [saleType, setSaleType] = useState(["Pipe For Sale (Buy Pipe)"]);
  const [pipeType, setPipeType] = useState([]);
  const [pipeSize, setPipeSize] = useState([]);
  const [pipeMaterial, setPipeMaterial] = useState([]);
  const [pipeCondition, setPipeCondition] = useState([]);
  const [pipeMillCert, setPipeMillCert] = useState([]);

  const [catagory1, setCategory1] = useState([]);
  const [make, setMake] = useState([]);
  const [model, setModel] = useState([]);
  const [region, setRegion] = useState([]);
  const [pageTittle, setPageTittle] = useState([
    "Global Marketplace for Asset Recovery and Surplus Inventory | Salvex",
  ]);
  const [gridView, setGridView] = useState(false);
  const [listings, setListings] = useState([]);
  const [queryData, setQueryData] = useState("");
  const [numberOfRecord, setNumberOfRecord] = useState(0);
  const [page, setPage] = useState(0);

  const [loadingMain, setLoadingMain] = useState(true);
  const [filterChange, setFilterChange] = useState("");
  const [showAskQuestion, setShowAskQuestion] = useState(false);
  const [askquestionItem, setAskQuestionItem] = useState({});
  const [showLogo, setShowLogo] = useState([]);

  const [showMfrModal, setShowMfrModal] = useState(false);
  const [item, setItem] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  //Sorting
  const [sort, setSort] = useState("asc");
  const [sortBy, setSortBy] = useState("MT");

  const toggleMfrModal = () => {
    if (showMfrModal) {
      setItem([]);
    }
    setShowMfrModal(!showMfrModal);
  };

  const toggleAskQuestion = () => {
    setShowAskQuestion(!showAskQuestion);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const searchData = parse(window.location.search);
      if (searchData?.saleType) {
        setSaleType(searchData?.saleType?.includes(",") ? [...searchData.saleType?.split(",")] : [searchData.saleType]);
      }
      if (searchData?.certicate) {
        setPipeMillCert(
          searchData?.certicate?.includes(",") ? [...searchData?.certicate?.split(",")] : [searchData.certicate],
        );
      }
      if (searchData?.size) {
        setPipeSize(searchData?.size?.includes(",") ? [...searchData?.size?.split(",")] : [searchData.size]);
      }
      if (searchData?.condition) {
        setPipeCondition(
          searchData?.condition?.includes(",") ? [...searchData?.condition?.split(",")] : [searchData.condition],
        );
      }
      if (searchData?.make) {
        setMake(searchData?.make?.includes(",") ? [...searchData?.make?.split(",")] : [searchData.make]);
      }
      if (searchData?.material) {
        setPipeMaterial(
          searchData?.material?.includes(",") ? [...searchData?.material?.split(",")] : [searchData.material],
        );
      }
      if (searchData?.pipeType) {
        setPipeType(
          searchData?.pipeType?.includes(",") ? [...searchData?.pipeType?.split(",")] : [searchData.pipeType],
        );
      }
      if (searchData?.region) {
        setRegion(searchData?.region?.includes(",") ? [...searchData?.region?.split(",")] : [searchData.region]);
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && localStorage.getItem("token")) {
      ref && ref.current && ref.current.continuousStart();
      const payload = {
        action: "Open Pipe Trading Screen",
      };
      updatePipeLog(payload, (res) => {
        if (res && res.status === 200) {
          ref && ref.current && ref.current.complete();
        } else {
          ref && ref.current && ref.current.complete();
        }
      });
    }
  }, []);

  const updatePipe = (a, b) => {
    if (typeof window !== "undefined" && localStorage.getItem("token")) {
      const payload = {
        listing_id: b,
        action: a,
      };
      updatePipeLog(payload, (res) => {
        if (res && res.status === 200) {
        } else {
        }
      });
    }
  };

  const clearFilter = (type) => {
    if (type === "saleType" || type === "all") {
      setSaleType([]);
    }
    if (type === "pipeType" || type === "all") {
      setPipeType([]);
    }
    if (type === "pipeCondition" || type === "all") {
      setPipeCondition([]);
    }
    if (type === "pipeSize" || type === "all") {
      setPipeSize([]);
    }
    if (type === "pipeMaterial" || type === "all") {
      setPipeMaterial([]);
    }
    if (type === "pipeMillCert" || type === "all") {
      setPipeMillCert([]);
    }
    if (type === "make" || type === "all") {
      setMake([]);
    }
    if (type === "region" || type === "all") {
      setRegion([]);
    }
  };
  const setData = (key, val) => {
    setFilterChange(key);
    if (key === "saleType") {
      const checkSaleType = saleType.find((v) => v === val);
      if (checkSaleType) {
        const newSaleType = saleType.filter((v) => v !== val);
        setSaleType(newSaleType);
      } else {
        const updateSaleType = [...saleType];
        updateSaleType.push(val);
        setSaleType(updateSaleType);
      }
    }

    if (key === "pipeType") {
      const checkPipeType = pipeType.find((v) => v === val);
      if (checkPipeType) {
        const newPipeType = pipeType.filter((v) => v !== val);
        setPipeType(newPipeType);
      } else {
        const updatePipeType = [...pipeType];
        updatePipeType.push(val);
        setPipeType(updatePipeType);
      }
    }

    if (key === "pipeCondition") {
      const checkPipeCondition = pipeCondition.find((v) => v === val);
      if (checkPipeCondition) {
        const newPipeCondition = pipeCondition.filter((v) => v !== val);
        setPipeCondition(newPipeCondition);
      } else {
        const updatePipeCondition = [...pipeCondition];
        updatePipeCondition.push(val);
        setPipeCondition(updatePipeCondition);
      }
    }

    if (key === "pipeMillCert") {
      const checkPipeMillCert = pipeMillCert.find((v) => v === val);
      if (checkPipeMillCert) {
        var newPipeMillCert = pipeMillCert.filter((v) => v !== val);
        if (checkPipeMillCert === "No") {
          var newCheckPipeMillCert = newPipeMillCert.filter((v) => v !== "false");
        } else {
          var newCheckPipeMillCert = newPipeMillCert.filter((v) => v !== "true");
        }
        setPipeMillCert(newCheckPipeMillCert);
      } else {
        const updatePipeMillCert = [...pipeMillCert];
        updatePipeMillCert.push(val);
        if (val === "No") {
          updatePipeMillCert.push("false");
        } else {
          updatePipeMillCert.push("true");
        }
        setPipeMillCert(updatePipeMillCert);
      }
    }

    if (key === "pipeMaterial") {
      const checkPipeMaterial = pipeMaterial.find((v) => v === val);
      if (checkPipeMaterial) {
        const newPipeMaterial = pipeMaterial.filter((v) => v !== val);
        setPipeMaterial(newPipeMaterial);
      } else {
        const updatePipeMaterial = [...pipeMaterial];
        updatePipeMaterial.push(val);
        setPipeMaterial(updatePipeMaterial);
      }
    }
    if (key === "pipeSize") {
      const checkPipeSize = pipeSize.find((v) => v === val);

      if (checkPipeSize) {
        const newPipeSize = pipeSize.filter((v) => v !== val);
        setPipeSize(newPipeSize);
      } else {
        const updatePipeSize = [...pipeSize];
        updatePipeSize.push(val);
        setPipeSize(updatePipeSize);
      }
    }
    if (key === "make") {
      const checkMake = make.find((v) => v === val);
      if (checkMake) {
        const newMake = make.filter((v) => v !== val);
        setMake(newMake);
      } else {
        const updateMake = [...make];
        updateMake.push(val);
        setMake(updateMake);
      }
    }
    if (key === "region") {
      const checkRegion = region.find((v) => v === val);
      if (checkRegion) {
        const newRegion = region.filter((v) => v !== val);
        setRegion(newRegion);
      } else {
        const updateRegion = [...region];
        updateRegion.push(val);
        setRegion(updateRegion);
      }
    }
  };

  const loadData = async (query = "") => {
    ref && ref.current && ref.current.continuousStart();
    try {
      const Qdata = queryString.parse(props.location.search);
      const filters = [];
      const categories0 = catagory.map((ec) => `categories.lvl0:${ec}`);
      const makes = make.map((ec) => `make:${ec}`);
      const saleTypes = saleType.map((ec) => `pipe.sale_type:${ec}`);
      const pipeTypes = pipeType.map((ec) => `pipe.pipe_type:${ec}`);
      const pipeConditions = pipeCondition.map((ec) => `pipe.pipe_condition:${ec}`);
      const pipeMaterials = pipeMaterial.map((ec) => `pipe.pipe_material:${ec}`);
      const pipeMillCerts = pipeMillCert.map((ec) => `pipe.pipe_mill_cert:${ec}`);
      const pipeSizes = pipeSize.map((ec) => `pipe.pipe_size:${ec}`);

      const models = model.map((ec) => `model:${ec}`);
      const regions = region.map((ec) => `region:${ec}`);

      if (categories0.length > 0) filters.push(categories0);
      if (pipeMaterials.length > 0) filters.push(pipeMaterials);
      if (pipeMillCerts.length > 0) filters.push(pipeMillCerts);
      if (pipeSizes.length > 0) filters.push(pipeSizes);
      if (makes.length > 0) filters.push(makes);
      if (models.length > 0) filters.push(models);
      if (regions.length > 0) filters.push(regions);

      ///pipe
      if (saleTypes.length > 0) filters.push(saleTypes);
      if (pipeTypes.length > 0) filters.push(pipeTypes);
      if (pipeConditions.length > 0) filters.push(pipeConditions);
      if (Qdata["enddate"]) {
        filters.push(`end_date:${Qdata["enddate"]}`);
      }

      const records = await index.search(queryData || queryString.parse(props.location.search).q, {
        facetFilters: filters,
        //numericFilters: ["date_posted > 1"],
        facets: [
          "make",
          "model",
          "region",
          "pipe.pipe_condition",
          "pipe.pipe_material",
          "pipe.pipe_mill_cert",
          "pipe.pipe_size",
          "pipe.pipe_type",
          "pipe.sale_type",
          "end_date",
        ],
        hitsPerPage: 1000,
        //page: page,
      });
      const listingsData = records.hits;
      setNumberOfRecord(records.nbHits);

      setListings(listingsData);

      if (filterChange) {
        const newF = facets;

        records.facets[
          filterChange === "catagory"
            ? "categories.lvl0"
            : filterChange === "pipeType"
            ? "pipe.pipe_type"
            : filterChange === "pipeSize"
            ? "pipe.pipe_size"
            : filterChange === "pipeMillCert"
            ? "pipe.pipe_mill_cert"
            : filterChange === "pipeMaterial"
            ? "pipe.pipe_material"
            : filterChange === "pipeCondition"
            ? "pipe.pipe_condition"
            : filterChange
        ] =
          newF[
            filterChange === "catagory"
              ? "categories.lvl0"
              : filterChange === "pipeType"
              ? "pipe.pipe_type"
              : filterChange === "pipeSize"
              ? "pipe.pipe_size"
              : filterChange === "pipeMillCert"
              ? "pipe.pipe_mill_cert"
              : filterChange === "pipeMaterial"
              ? "pipe.pipe_material"
              : filterChange === "pipeCondition"
              ? "pipe.pipe_condition"
              : filterChange
          ];
        setFacets(records.facets);
      } else {
        setFacets(records.facets);
      }

      setLoadingMain(false);
    } catch (e) {
      if (e.status === 400) {
        navigate("/404");
      } else if (e.status === 500) {
        navigate("/500");
      }
    }
    ref.current && ref.current.complete();
  };
  useEffect(() => {
    setLoadingMain(true);
    if (queryString.parse(props.location.search).q) {
      setQueryData(queryString.parse(props.location.search).q);
    } else {
      loadData();
    }
  }, []);
  useEffect(() => {
    setPage(0);
    loadData();
  }, [
    queryData,
    catagory,
    catagory1,
    make,
    region,
    saleType,
    pipeType,
    pipeCondition,
    pipeMillCert,
    pipeSize,
    pipeMaterial,
  ]);

  useEffect(() => {
    loadData();
  }, [page]);

  useEffect(() => {
    if (sortBy == "MT") {
      if (sort == "asc") {
        const a2 =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.pipe?.pipe_tonnage && b?.pipe?.pipe_tonnage
              ? Number(a?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, "")) -
                Number(b?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, ""))
              : !a?.pipe?.pipe_tonnage && b?.pipe?.pipe_tonnage
              ? 0 - Number(b?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, ""))
              : a?.pipe?.pipe_tonnage && !b?.pipe?.pipe_tonnage
              ? Number(a?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, "")) - 0
              : "",
          );

        setListings(a2);
      } else if (sort == "desc") {
        const a2 =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.pipe?.pipe_tonnage && b?.pipe?.pipe_tonnage
              ? Number(b?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, "")) -
                Number(a?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, ""))
              : !a?.pipe?.pipe_tonnage && b?.pipe?.pipe_tonnage
              ? Number(b?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, "")) - 0
              : a?.pipe?.pipe_tonnage && !b?.pipe?.pipe_tonnage
              ? 0 - Number(a?.pipe?.pipe_tonnage.replace(/(^\$|,)/g, ""))
              : "",
          );

        setListings(a2);
      }
    } else if (sortBy == "Length") {
      if (sort == "asc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.pipe?.pipe_total_length && b?.pipe?.pipe_total_length
              ? Number(a?.pipe?.pipe_total_length.replace(/(^\$|,)/g, "")) -
                Number(b?.pipe?.pipe_total_length.replace(/(^\$|,)/g, ""))
              : !a?.pipe?.pipe_total_length && b?.pipe?.pipe_total_length
              ? 0 - Number(b?.pipe?.pipe_total_length.replace(/(^\$|,)/g, ""))
              : a?.pipe?.pipe_total_length && !b?.pipe?.pipe_total_length
              ? Number(a?.pipe?.pipe_total_length.replace(/(^\$|,)/g, "")) - 0
              : "",
          );
        setListings(a);
      } else if (sort == "desc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.pipe?.pipe_total_length && b?.pipe?.pipe_total_length
              ? Number(b?.pipe?.pipe_total_length.replace(/(^\$|,)/g, "")) -
                Number(a?.pipe?.pipe_total_length.replace(/(^\$|,)/g, ""))
              : !a?.pipe?.pipe_total_length && b?.pipe?.pipe_total_length
              ? Number(b?.pipe?.pipe_total_length.replace(/(^\$|,)/g, "")) - 0
              : a?.pipe?.pipe_total_length && !b?.pipe?.pipe_total_length
              ? 0 - Number(a?.pipe?.pipe_total_length.replace(/(^\$|,)/g, ""))
              : "",
          );
        setListings(a);
      }
    } else if (sortBy == "MTC") {
      if (sort == "asc") {
        const z = [];
        const data = [...listings];
        const a =
          data &&
          data.length > 0 &&
          data.map((item) => {
            const b = { ...item };

            if (b?.pipe?.pipe_mill_cert == "true" || b?.pipe?.pipe_mill_cert == "Yes") {
              b.pipe.pipe_mill_cert = "Yes";
            } else {
              b.pipe.pipe_mill_cert = "No";
            }
            z.push(b);
          });
        const newArray = z.sort((a, b) =>
          (a?.pipe?.pipe_mill_cert || "").toString().localeCompare((b?.pipe?.pipe_mill_cert || "").toString()),
        );

        setListings(newArray);
      } else if (sort == "desc") {
        const z = [];
        const data = [...listings];
        const a =
          data &&
          data.length > 0 &&
          data.map((item) => {
            const b = { ...item };

            if (b?.pipe?.pipe_mill_cert == "true" || b?.pipe?.pipe_mill_cert == "Yes") {
              b.pipe.pipe_mill_cert = "Yes";
            } else {
              b.pipe.pipe_mill_cert = "No";
            }
            z.push(b);
          });

        const newArray = z.sort((a, b) =>
          (b?.pipe?.pipe_mill_cert || "").toString().localeCompare((a?.pipe?.pipe_mill_cert || "").toString()),
        );

        setListings(newArray);
      }
    } else if (sortBy == "Origin") {
      if (sort == "asc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            (b?.pipe?.pipe_origin_country || "")
              .toString()
              .localeCompare((a?.pipe?.pipe_origin_country || "").toString()),
          );
        setListings(a);
      } else if (sort == "desc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            (a?.pipe?.pipe_origin_country || "")
              .toString()
              .localeCompare((b?.pipe?.pipe_origin_country || "").toString()),
          );
        setListings(a);
      }
    } else if (sortBy == "item") {
      if (sort == "asc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) => (b?.title || "").toString().localeCompare((a?.title || "").toString()));
        setListings(a);
      } else if (sort == "desc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) => (a?.title || "").toString().localeCompare((b?.title || "").toString()));
        setListings(a);
      }
    } else if (sortBy == "Year") {
      if (sort == "asc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.pipe?.pipe_year && b?.pipe?.pipe_year
              ? Number(a?.pipe?.pipe_year.replace(/(^\$|,)/g, "")) - Number(b?.pipe?.pipe_year.replace(/(^\$|,)/g, ""))
              : !a?.pipe?.pipe_year && b?.pipe?.pipe_year
              ? 0 - Number(b?.pipe?.pipe_year.replace(/(^\$|,)/g, ""))
              : a?.pipe?.pipe_year && !b?.pipe?.pipe_year
              ? Number(a?.pipe?.pipe_year.replace(/(^\$|,)/g, "")) - 0
              : "",
          );
        setListings(a);
      } else if (sort == "desc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.pipe?.pipe_year && b?.pipe?.pipe_year
              ? Number(b?.pipe?.pipe_year.replace(/(^\$|,)/g, "")) - Number(a?.pipe?.pipe_year.replace(/(^\$|,)/g, ""))
              : !a?.pipe?.pipe_year && b?.pipe?.pipe_year
              ? Number(b?.pipe?.pipe_year.replace(/(^\$|,)/g, "")) - 0
              : a?.pipe?.pipe_year && !b?.pipe?.pipe_year
              ? 0 - Number(a?.pipe?.pipe_year.replace(/(^\$|,)/g, ""))
              : "",
          );
        setListings(a);
      }
    } else if (sortBy == "Price") {
      if (sort == "asc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.asking_price && b?.asking_price
              ? Number(`${a?.asking_price}`.replace(/(^\$|,)/g, "")) -
                Number(`${b?.asking_price}`.replace(/(^\$|,)/g, ""))
              : !a?.asking_price && b?.asking_price
              ? 0 - Number(`${b?.asking_price}`.replace(/(^\$|,)/g, ""))
              : a?.asking_price && !b?.asking_price
              ? Number(`${a?.asking_price}`.replace(/(^\$|,)/g, "")) - 0
              : "",
          );
        setListings(a);
      } else if (sort == "desc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) =>
            a?.asking_price && b?.asking_price
              ? Number(`${b?.asking_price}`.replace(/(^\$|,)/g, "")) -
                Number(`${a?.asking_price}`.replace(/(^\$|,)/g, ""))
              : !a?.asking_price && b?.asking_price
              ? Number(`${b?.asking_price}`.replace(/(^\$|,)/g, "")) - 0
              : a?.asking_price && !b?.asking_price
              ? 0 - Number(`${a?.asking_price}`.replace(/(^\$|,)/g, ""))
              : "",
          );
        setListings(a);
      }
    } else if (sortBy == "Location") {
      if (sort == "asc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) => (a?.location || "").toString().localeCompare((b?.location || "").toString()));
        setListings(a);
      } else if (sort == "desc") {
        const a =
          listings &&
          listings.length > 0 &&
          listings.sort((a, b) => (b?.location || "").toString().localeCompare((a?.location || "").toString()));
        setListings(a);
      }
    }
  }, [sort, sortBy]);

  const handleChange = (event, value) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setPage(value - 1);
  };

  let pages = _.range(
    page - 5 < 0 ? 0 : page - 5,
    Math.ceil(numberOfRecord / 50) > 10 ? page + 5 : Math.ceil(numberOfRecord / 50),
  );
  const removeFilter = (index, type) => {
    if (type === "pipeType") {
      const data = [...pipeType];

      data.splice(index, 1);

      setPipeType(data);
    }
    if (type === "saleType") {
      const data = [...saleType];
      data.splice(index, 1);
      setSaleType(data);
    }
    if (type === "pipeCondition") {
      const data = [...pipeCondition];
      data.splice(index, 1);
      setPipeCondition(data);
    }
    if (type === "pipeMaterial") {
      const data = [...pipeMaterial];
      data.splice(index, 1);
      setPipeMaterial(data);
    }
    if (type === "pipeMillCert") {
      const data = [...pipeMillCert];
      if (index === "No" || index === "false") {
        var newData = data.filter((v) => v !== "No").filter((ve) => ve !== "false");
      } else {
        var newData = data.filter((v) => v !== "Yes").filter((ve) => ve !== "true");
      }
      // data.splice(index, 1)
      setPipeMillCert(newData);
    }
    if (type === "pipeSize") {
      const data = [...pipeSize];
      data.splice(index, 1);
      setPipeSize(data);
    }
    if (type === "make") {
      const data = [...make];
      data.splice(index, 1);
      setMake(data);
    }
    if (type === "region") {
      const data = [...region];
      data.splice(index, 1);
      setRegion(data);
    }
  };

  let filterCount = 0;
  if (saleType.length > 0) {
    filterCount = filterCount + saleType.length;
  }
  if (pipeType.length > 0) {
    filterCount = filterCount + pipeType.length;
  }
  if (pipeCondition.length > 0) {
    filterCount = filterCount + pipeCondition.length;
  }
  if (make.length > 0) {
    filterCount = filterCount + make.length;
  }
  if (region.length > 0) {
    filterCount = filterCount + region.length;
  }
  if (pipeSize.length > 0) {
    filterCount = filterCount + pipeSize.length;
  }
  if (pipeMaterial.length > 0) {
    filterCount = filterCount + pipeMaterial.length;
  }
  if (pipeMillCert.length > 0) {
    filterCount = filterCount + pipeMillCert.length;
  }

  const member = typeof window !== "undefined" && JSON.parse(localStorage.getItem("member"));
  const mimicmember = typeof window !== "undefined" && JSON.parse(localStorage.getItem("mimicmember"));

  const tradingId = mimicmember
    ? mimicmember.company_access
    : member && member.company_access
    ? member.company_access
    : 0;

  // const tradingId = 2;

  const handleShowLogo = (e) => {
    try {
      ref && ref.current && ref.current.continuousStart();
      const id = e && e.auction_id;
      const data = {
        auction_id: id,
      };
      showPipeLogo(data, (res) => {
        if (res.status === 200) {
          const a = res.data.company;
          a.auction_id = id;
          const data = [...showLogo];
          data.push(id);
          setSelectedItems([...selectedItems, a]);
          setShowLogo(data);
          ref.current && ref.current.complete();
        } else {
          const a = { name: null, proc_logo: null };
          a.auction_id = id;
          const data = [...showLogo];
          data.push(id);
          setSelectedItems([...selectedItems, a]);
          setShowLogo(data);
          ref.current && ref.current.complete();
          // toast(
          //   <AlertError message={res && res.data && res.data.message ? res.data.message : "Something Went Wrong"} />,
          // );
        }
      });
    } catch (err) {
      console.log("Err=>", err);
    }
  };

  const isLoggedIn = typeof window !== "undefined" && localStorage.getItem("token") ? true : false;

  return (
    <>
      <LoadingBar color="#47ad1d" ref={ref} />
      <Header />
      <>
        <div class="filter-outer-container">
          <div class="filter-container w-lg-100 d-lg-flex flex-lg-wrap filter-pipe-container">
            <PipeFilterSidebar
              facets={facets}
              setData={setData}
              saleType={saleType}
              pipeType={pipeType}
              pipeCondition={pipeCondition}
              pipeMillCert={pipeMillCert}
              pipeSize={pipeSize}
              pipeMaterial={pipeMaterial}
              catagory={catagory}
              catagory1={catagory1}
              make={make}
              model={model}
              region={region}
              toggleFilter={() => setShowFilterModal(!showFilterModal)}
              filterModalData={(data) => setFilterModalData(data)}
              filterModalDataCounts={(count) => setFilterModalDataCounts(count)}
              modalType={(t) => setModalType(t)}
              clearFilter={(val) => clearFilter(val)}
              removeFilter={removeFilter}
              loadingMain={loadingMain}
            />
            <div class="npc-main-content-box">
              <div class="npcm-header">
                {loadingMain ? (
                  <Skeleton width={500} height={15} />
                ) : (
                  <h1>OCTG, Line Pipe, Drill Pipe For Sale (Surplus, Used, Structural, and Scrap)</h1>
                )}
                {loadingMain ? (
                  <div className="my-3">
                    <Skeleton width="100%" height={15} />
                    <Skeleton width="100%" height={15} />
                    <Skeleton width="100%" height={15} />
                    <Skeleton width="100%" height={15} />
                    <Skeleton width="100%" height={15} />
                  </div>
                ) : (
                  <p>
                    Welcome to the first and most comprehensive global pipe market place powered by Salvex. This site is
                    designed specifically for sellers and buyers of OCTG (Casing &amp; Tubing), Line Pipe, Drill Pipe
                    and Construction Pipe to make connections selling their surplus inventories and locate pipe needed
                    for upcoming projects. For large oil companies and construction companies we offer enterprise
                    software which included redeployment software to reuse assets in other internal projects and
                    comprehensive asset recovery solution for the public sale of assets. Salvex has completed sales in
                    all global regions including USA, Canada, Central America, Europe, Africa, Middle East, South East
                    Asia, Australia, CIS Countries, Asia and South America. If you have anything to post, comments, or
                    questions please feel free to contact customer service{" "}
                    <a href="javascript:void(0)"> pipe@salvex.com.</a>
                  </p>
                )}

                <div
                  class={
                    loadingMain
                      ? "new-tab-container d-flex align-items-center justify-content-between p-0"
                      : "new-tab-container"
                  }
                  dir="rtl"
                >
                  {loadingMain ? (
                    [1, 2, 3, 4, 5, 6, 7].map((s) => (
                      <div>
                        <Skeleton width={120} height={15} />
                      </div>
                    ))
                  ) : (
                    <Slider
                      {...productSlider}
                      className="new-tab-list add-tab-slider pipe-slider add-custom-arrow d-flex flex-wrap slick-initialized slick-slider"
                    >
                      <li
                        class={`ntl-item slick-slide  ${tab === 1 ? "active" : ""}`}
                        data-slick-index="1"
                        aria-hidden="false"
                        tabindex="0"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(1);
                          }}
                          class="ntl-link"
                          tabindex="0"
                        >
                          Pipe Listing ({numberOfRecord})
                        </a>
                      </li>
                      <li
                        class={`ntl-item slick-slide  ${tab === 2 ? "active" : ""}`}
                        data-slick-index="2"
                        aria-hidden="false"
                        tabindex="0"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(2);
                          }}
                          class="ntl-link"
                          tabindex="0"
                        >
                          Pipe Logistics Support
                        </a>
                      </li>
                      <li
                        class={`ntl-item slick-slide  ${tab === 3 ? "active" : ""}`}
                        data-slick-index="3"
                        aria-hidden="false"
                        tabindex="0"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(3);
                          }}
                          class="ntl-link"
                          tabindex="0"
                        >
                          OCTG Pipe Sales
                        </a>
                      </li>
                      <li
                        class={`ntl-item slick-slide  ${tab === 4 ? "active" : ""}`}
                        data-slick-index="4"
                        aria-hidden="false"
                        tabindex="0"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(4);
                          }}
                          class="ntl-link"
                          tabindex="0"
                        >
                          Drill Pipe Sales
                        </a>
                      </li>
                      <li
                        class={`ntl-item slick-slide  ${tab === 5 ? "active" : ""}`}
                        data-slick-index="5"
                        aria-hidden="false"
                        tabindex="0"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(5);
                          }}
                          class="ntl-link"
                          tabindex="0"
                        >
                          Line Pipe Sale
                        </a>
                      </li>
                      <li
                        class={`ntl-item slick-slide  ${tab === 6 ? "active" : ""}`}
                        data-slick-index="6"
                        aria-hidden="false"
                        tabindex="0"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(6);
                          }}
                          class="ntl-link"
                          tabindex="0"
                        >
                          Global Pipe Coverage
                        </a>
                      </li>
                      <li
                        class={`ntl-item slick-slide  ${tab === 7 ? "active" : ""}`}
                        data-slick-index="7"
                        aria-hidden="true"
                        tabindex="-1"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(7);
                          }}
                          class="ntl-link"
                          tabindex="-1"
                        >
                          Structural and Pilling Pipe Sales
                        </a>
                      </li>
                      <li
                        class={`ntl-item slick-slide  ${tab === 8 ? "active" : ""}`}
                        data-slick-index="8"
                        aria-hidden="true"
                        tabindex="-1"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(8);
                          }}
                          class="ntl-link"
                          tabindex="-1"
                        >
                          Salvex Global Pipe Exchange
                        </a>
                      </li>
                    </Slider>
                  )}
                </div>
              </div>

              {tab === 7 && (
                <div class="npcm-body">
                  <div class="npcm-content">
                    <h3>Structural and Pilling Pipe Sales</h3>
                    <p>
                      Some of the pipe originally intended for specific oil and gas or construction projects is not used
                      for its original purpose. In this case, Salvex helps corporations to sell their older material.
                      There may be missing documentation, lack of traceability, levels of rust, or simply the material
                      is too old to be used for its original purpose.
                    </p>
                  </div>
                </div>
              )}
              {tab === 8 && (
                <div class="npcm-body">
                  <div class="npcm-content">
                    <h3> Salvex Global Pipe Exchange</h3>
                    <p>
                      Salvex has all common sizes and specifications for sale on www.salvexpipe.com. If any there is a
                      size that is required that is not visible on our site, please send an email to sales@salvex.com or
                      pipe@salvex.com and our team will check our offline inventory.
                    </p>
                  </div>
                </div>
              )}
              {tab === 6 && (
                <div class="npcm-body">
                  <div class="npcm-content">
                    <h3>Global Pipe Coverage</h3>
                    <p>
                      <p>
                        Salvex has completed sales in all global regions for major oil and gas companies. Some of the
                        locations where our team is currently working on projects include:
                      </p>
                      <ul className="dot-list">
                        <li>
                          <strong>North America</strong>
                          <p>USA and Canada</p>
                        </li>
                        <li>
                          <strong>Latin America &amp; Caribbean</strong>
                          <p>Mexico, Belize, Trinidad, Guyana, etc.</p>
                        </li>
                        <li>
                          <string>
                            South America
                            <p>Brazil, Argentina, Uruguay, Peru, Ecuador, Venezuela, etc.</p>
                          </string>
                        </li>
                        <li>
                          <strong>Africa</strong>
                          <p>
                            South Africa, Angola, Equatorial Guinea, Nigeria, Ghana, Cote D’Ivoire, Tanzania, Kenya,
                            Egypt, Tunisia, Libya, Morocco, Chad, Mauritania, etc.
                          </p>
                        </li>
                        <li>
                          <strong>Europe</strong>
                          <p>
                            UK, Norway, France, Germany, Spain, Italy, Romania, Poland, Czech Republic, Ukraine, Russia,
                            Israel, etc.
                          </p>
                        </li>
                        <li>
                          <strong>Middle East</strong>
                          <p>United Arab Emirates, Saudi Arabia, Bahrain, Qatar, Kuwait, Iraq, Oman, etc.</p>
                        </li>
                        <li>
                          <strong>CIS Countries</strong>
                          <p>Kazakhstan, Uzbekistan, Azerbaijan, Turkmenistan, etc.</p>
                        </li>
                        <li>
                          <strong>Asia</strong>
                          <p>
                            Pakistan, India, Bangladesh, Vietnam, Thailand, Malaysia, Singapore, Indonesia, Brunei,
                            Papua New Guinea, Philippines, China, Australia, New Zealand, etc.
                          </p>
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              )}
              {tab === 5 && (
                <div class="npcm-body">
                  <div class="npcm-content">
                    <h3>Line Pipe Sale</h3>
                    <p>
                      Salvex regularly completes sales of Line Pipe from recently cancelled or completed projects. The
                      sizes that Salvex has access to ranges from 3 ½" to 48" and is available in all API 5L grades.
                    </p>
                  </div>
                </div>
              )}
              {tab === 4 && (
                <div class="npcm-body">
                  <div class="npcm-content">
                    <h3>Drill Pipe Sales</h3>
                    <p>
                      Salvex provides corporations an online platform to sell their API drill pipe (2 3/8" to 6 5/8")
                      drill pipe with all common grades (X95, G105 and S135).
                    </p>
                  </div>
                </div>
              )}
              {tab === 3 && (
                <div class="npcm-body">
                  <div class="npcm-content">
                    <h3>OCTG Pipe Sales</h3>
                    <p>
                      The Upstream Segment of the Oil & Gas Industry relies on Oil Country Tubular Goods (OCTG) as one
                      its main products for the drilling process. The main characteristics of Casing and Tubing are the
                      Outer Diameter (OD), Weight per linear foot or meter, thickness of the pipe wall (also known as
                      body wall), grade of material strength, chemical composition, and end connections and threads.
                      Full length Casing and Tubing is available in either Range 2 (30 foot average) or Range 3 (40 foot
                      average) lengths.
                    </p>

                    <p>
                      Salvex has Casing and Tubing for sale in all global regions. The Pipe is either is unused or has
                      been previously been used in operations. The OCTG that is currently available for sale from
                      recently cancelled or completed projects consists of material with both API Standard steel grades
                      and connections and proprietary mill grades and connections. Our global coverage lets operators,
                      stockists, and resellers to view and purchase Carbon Steel (K55, L80, N80, P110, Q125, etc.) and
                      Chrome (13CR, 22CR, 25CR, etc.)
                    </p>

                    <p>
                      Salvex has all common sizes and specifications for sale on www.salvexpipe.com. If any there is a
                      size that is required that is not visible on our site, please send an email to sales@salvex.com or
                      pipe@salvex.com and our team will check our offline inventory.
                    </p>
                  </div>
                </div>
              )}
              {tab === 2 && (
                <div class="npcm-body">
                  <div class="npcm-content">
                    <h3>Pipe Logistics Support</h3>

                    <p>
                      Salvex understands that logistics support can play a large role in a successful transaction. Our
                      experienced team works daily on pipe sales that require different levels of logistics support and
                      set a standard to ensure that the post transaction process is completed smoothly and all potential
                      issues are prevented rather than encountered during the collection process. Salvex is in regular
                      contact with Freight Forwarding companies that specialize in the movement of piping materials. Our
                      team is able to provide logistics support whether it is one truck load or 4,000 metric tons of
                      material being loaded on a vessel. OCTG Pipe Sales
                    </p>
                  </div>
                </div>
              )}
              {tab === 1 && (
                <>
                  {loadingMain ? (
                    <div class="npcm-body">
                      <div class="npc-top d-md-flex align-items-md-center justify-content-md-between">
                        <div className="npc-top-left">
                          <Skeleton width={200} height={15} />
                        </div>
                        <div class="npc-top-right d-flex align-items-center" style={{ gap: "10px" }}>
                          <Skeleton width={180} height={15} />
                          <div class="choose-list-type d-flex align-items-center" style={{ gap: "10px" }}>
                            <Skeleton width={15} height={15} />
                            <Skeleton width={15} height={15} />
                          </div>
                        </div>
                      </div>
                      {gridView ? (
                        <ul class="new-product-list new-product-slider d-flex flex-wrap">
                          {listings
                            .filter((ls) => ls.end_date !== "Surplus Inventory")
                            .map((e) => (
                              <li class="npl-item">
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => {
                                    if (isMobile) {
                                      navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                    } else {
                                      navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                    }
                                  }}
                                >
                                  <div class="npl-box">
                                    <div class="npl-img">
                                      <img src={e.image} alt={e.title} />
                                    </div>
                                    <div class="npl-content">
                                      <h4>{e.title}</h4>
                                      <p>{e.category}</p>
                                      <p class="grid-pick-intro">{e.quantity}</p>
                                      <small class="grid-location-desc">{e.location}</small>
                                      <h6>
                                        Asking Price - <strong>{e.asking_price ? "$" + e.asking_price : "N/A"}</strong>
                                      </h6>
                                    </div>
                                  </div>
                                </a>
                              </li>
                            ))}
                        </ul>
                      ) : (
                        <div class="table-responsive mb-30">
                          <table class="product-list-table table table-bordered table-wrap">
                            <thead class="table-light">
                              <tr>
                                <th>
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                                <th>
                                  {" "}
                                  <Skeleton width="100%" height={13} />
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {[1, 2, 3, 4, 5, 6, 7].map((e, i) => (
                                <tr>
                                  <td>
                                    <div>
                                      {" "}
                                      <Skeleton width="100%" height={13} />
                                    </div>
                                  </td>
                                  {/* <td>
                                    <div>
                                      <Skeleton width="100%" height={13} />
                                    </div>
                                  </td> */}
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                  <td>
                                    <Skeleton width="100%" height={13} />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {listings && listings.length > 0 ? (
                        <>
                          {listings.filter((ls) => ls.end_date !== "Surplus Inventory").length > 0 && (
                            <>
                              <div class="npcm-body">
                                <div class="npc-top d-md-flex align-items-md-center justify-content-md-between">
                                  <div className="npc-top-left">
                                    Active Auctions (
                                    {listings.filter((ls) => ls.end_date !== "Surplus Inventory").length})
                                  </div>
                                  <div class="npc-top-right d-flex align-items-center">
                                    <h6>MTC=Mill Test Certificates</h6>
                                    {/* <div class="choose-list-type">
                                      <a
                                        href="javascript:void(0)"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setGridView(false);
                                        }}
                                        class={gridView ? "listview-icon" : "listview-icon active"}
                                      >
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 4H3V6H5V4Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M5 11H3V13H5V11Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M5 18H3V20H5V18Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <line
                                            x1="10.75"
                                            y1="5.25"
                                            x2="21.25"
                                            y2="5.25"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          ></line>
                                          <line
                                            x1="10.75"
                                            y1="12.25"
                                            x2="21.25"
                                            y2="12.25"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          ></line>
                                          <line
                                            x1="10.75"
                                            y1="19.25"
                                            x2="21.25"
                                            y2="19.25"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          ></line>
                                        </svg>
                                      </a>
                                      <a
                                        href="javascript:void(0)"
                                        class={gridView ? "gridview-icon active" : "gridview-icon"}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setGridView(true);
                                        }}
                                      >
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10 3H3V10H10V3Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M21 3H14V10H21V3Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M21 14H14V21H21V14Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M10 14H3V21H10V14Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                      </a>
                                    </div> */}
                                  </div>
                                </div>

                                <div class="four-column-radio-group sale-type-radio fw-medium mb-4">
                                  <div class="fcrg-item">
                                    <div class="form-check radio">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="ABflexRadioDefault"
                                        id="ABflexRadio__112"
                                        onClick={() => setSaleType(["Pipe For Sale (Buy Pipe)"])}
                                        checked={saleType == "Pipe For Sale (Buy Pipe)"}
                                      />
                                      <label class="form-check-label" for="ABflexRadio__112">
                                        Surplus Pipe For Sale
                                      </label>
                                    </div>
                                  </div>
                                  <div class="fcrg-item">
                                    <div class="form-check radio">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="ABflexRadioDefault"
                                        id="ABflexRadio__211"
                                        onClick={() => setSaleType(["Wanted Pipe (Sell Pipe)"])}
                                        checked={saleType == "Wanted Pipe (Sell Pipe)"}
                                      />
                                      <label class="form-check-label" for="ABflexRadio__211">
                                        Wanted
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                {gridView ? (
                                  <ul class="new-product-list new-product-slider d-flex flex-wrap">
                                    {listings
                                      .filter((ls) => ls.end_date !== "Surplus Inventory")
                                      .map((e) => (
                                        <li class="npl-item">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={() => {
                                              updatePipe("Open Listing Details", e.auction_id);
                                              if (isMobile) {
                                                navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                              } else {
                                                navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                              }
                                            }}
                                          >
                                            <div class="npl-box">
                                              <div class="npl-img">
                                                <img src={e.image} alt={e.title} />
                                              </div>
                                              <div class="npl-content">
                                                <h4>{e.title}</h4>
                                                <p>{e.category}</p>
                                                <p class="grid-pick-intro">{e.quantity}</p>
                                                <small class="grid-location-desc">{e.location}</small>
                                                <h6>
                                                  Asking Price -{" "}
                                                  <strong>{e.asking_price ? "$" + e.asking_price : "N/A"}</strong>
                                                </h6>
                                              </div>
                                            </div>
                                          </a>
                                        </li>
                                      ))}
                                  </ul>
                                ) : (
                                  <InfiniteScroll
                                    initialLoad={false}
                                    pageStart={0}
                                    // loadMore={(e) => {
                                    //   if (listings?.filter((ls) => ls.end_date !== "Surplus Inventory")?.length > e) setCatPage(e);
                                    // }}
                                    hasMore={!loadingMain}
                                    useWindow={true}
                                    // loader={
                                    //   <div className="loader" key={0}>
                                    //     Loading ...
                                    //   </div>
                                    // }
                                  >
                                    <div class="table-responsive mb-30 ">
                                      <table class="product-list-table table table-bordered table-wrap pipe-table-fix pipe-table-fix-new">
                                        <thead class="table-light">
                                          <tr>
                                            <th>SR#</th>
                                            {/* {(tradingId === 2 || tradingId === 3) && <th>Ownership</th>} */}
                                            <th>Type</th>
                                            <th
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("item");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                              colspan="2"
                                            >
                                              <span className="standard-font-page-title">Item </span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              style={{ minWidth: "215px" }}
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("Price");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title "> Price</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer  "
                                              onClick={() => {
                                                setSortBy("MT");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">MT </span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("Length");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Length (feet)</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>

                                            <th
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("MTC");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">MTC</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("Origin");
                                                if (sort == "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Mill/Origin</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("Year");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Year</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("Location");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Location</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>

                                            <th>Question</th>
                                            <th>Pipe Trading</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {listings
                                            .filter((ls) => ls.end_date !== "Surplus Inventory")
                                            .map((e, i) => {
                                              const filteredData =
                                                selectedItems && selectedItems.length > 0
                                                  ? selectedItems.filter((item) => item.auction_id === e.auction_id)[0]
                                                  : [];
                                              return (
                                                <tr>
                                                  <td>
                                                    <div>{i + 1}</div>
                                                  </td>
                                                  {/* {(tradingId === 2 || tradingId === 3) &&
                                                  !showLogo.includes(e.auction_id) && (
                                                    <td>
                                                      <div
                                                        class="accor-table-label text-capitalize yellow-bg bid hover-color yellow-show-owner"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() => {
                                                          updatePipe("Showed Owner of Listing", e.auction_id);
                                                          handleShowLogo(e);
                                                        }}
                                                      >
                                                        Show Owner
                                                      </div>
                                                    </td>
                                                  )}
                                                {(tradingId === 2 || tradingId === 3) &&
                                                  showLogo.includes(e.auction_id) && (
                                                    <td>
                                                      <div class="td-img-pipe-logo mfr-logo-width">
                                                        {filteredData.proc_logo ? (
                                                          <img
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                              setItem([
                                                                {
                                                                  original:
                                                                    process.env.GATSBY_MEDIA_URL +
                                                                    "/co/logos/" +
                                                                    filteredData.proc_logo,
                                                                },
                                                              ]);
                                                              toggleMfrModal();
                                                            }}
                                                            src={
                                                              process.env.GATSBY_MEDIA_URL +
                                                              "/co/logos/" +
                                                              filteredData.proc_logo
                                                            }
                                                            alt="proc_logo"
                                                          />
                                                        ) : (
                                                          <p
                                                            style={{
                                                              fontWeight: "600",
                                                            }}
                                                          >
                                                            {filteredData.name ? filteredData.name : "N/A"}
                                                          </p>
                                                        )}
                                                      </div>
                                                    </td>
                                                  )} */}

                                                  <td>
                                                    {e.pipe && e.pipe.sale_type === "Wanted Pipe (Sell Pipe)" ? (
                                                      <span
                                                        style={{
                                                          color: "#29c1f2",
                                                        }}
                                                      >
                                                        Wanted
                                                      </span>
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#227300",
                                                        }}
                                                      >
                                                        Auction Inventory
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td>
                                                    <div class="td-img">
                                                      <img src={e.image} alt={e.title} />
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <a
                                                      href="javascript:void(0)"
                                                      onClick={() => {
                                                        updatePipe("Open Listing Details", e.auction_id);
                                                        if (isMobile) {
                                                          navigate(
                                                            `/listings/listing_detail.cfm/aucid/${e.auction_id}`,
                                                          );
                                                        } else {
                                                          navigate(
                                                            `/listings/listing_detail.cfm/aucid/${e.auction_id}`,
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      {e.title}
                                                    </a>
                                                  </td>
                                                  <td>
                                                    {e.asking_price > 0 ? (
                                                      <div class="grid7-offer d-flex flex-column align-items-start">
                                                        <div class="offer-total">
                                                          ${" "}
                                                          {parseFloat(e.asking_price)
                                                            .toString()
                                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                        </div>
                                                        <div
                                                          class="offer-badge cursor-pointer"
                                                          onClick={(ed) => {
                                                            ed.preventDefault();
                                                            ed.stopPropagation();
                                                            if (isLoggedIn) {
                                                              navigate(
                                                                `/listings/listing_detail.cfm/aucid/${e.auction_id}`,
                                                                {
                                                                  state: { buyNowClicked: true },
                                                                },
                                                              );
                                                            } else {
                                                              typeof window !== "undefined" &&
                                                                localStorage.setItem(
                                                                  "redirectUrl",
                                                                  `/pipe/?pipeType=${pipeType
                                                                    ?.map((ie) => ie)
                                                                    .join(",")}&condition=${pipeCondition
                                                                    ?.map((ew) => ew)
                                                                    .join(",")}&make=${make
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&region=${region
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&saleType=${saleType
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&size=${pipeSize
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&material=${pipeMaterial
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&cerificate=${pipeMillCert
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}`,
                                                                );
                                                              navigate("/members/login");
                                                            }
                                                          }}
                                                        >
                                                          Buy Now or Counter Offer
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {e.wholesale_value > 0 ? (
                                                      <div class="grid7-highlighted-content w-100">
                                                        <div class="g-h-label">Wholesale Value</div>
                                                        <div class="g-h-total">
                                                          <span>
                                                            $
                                                            {parseFloat(e.wholesale_value)
                                                              .toString()
                                                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </td>
                                                  <td>
                                                    {e.pipe &&
                                                      e.pipe.pipe_tonnage &&
                                                      parseFloat(e.pipe.pipe_tonnage)
                                                        .toFixed(2)
                                                        .toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                  </td>
                                                  <td>
                                                    {e.pipe &&
                                                      e.pipe.pipe_total_length &&
                                                      parseFloat(Math.trunc(e.pipe.pipe_total_length))
                                                        .toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                  </td>

                                                  <td>
                                                    {(e.pipe && e.pipe.pipe_mill_cert === "Yes") ||
                                                    (e.pipe && e.pipe.pipe_mill_cert === "true")
                                                      ? "Yes"
                                                      : (e.pipe && e.pipe.pipe_mill_cert === "No") ||
                                                        (e.pipe && e.pipe.pipe_mill_cert === "false")
                                                      ? "No"
                                                      : ""}
                                                  </td>
                                                  <td>
                                                    {e.pipe && e.pipe.pipe_origin_country
                                                      ? e.pipe.pipe_origin_country
                                                      : "N/A"}
                                                  </td>
                                                  <td>{e.pipe && e.pipe.pipe_year ? e.pipe.pipe_year : "N/A"}</td>
                                                  <td>{e.location ? e.location : "N/A"}</td>

                                                  <td
                                                    class="ms-3 dark-green-text text-decoration-underline bid ask-question cursor-pointer"
                                                    onClick={() => {
                                                      if (isLoggedIn) {
                                                        setAskQuestionItem(e);
                                                        toggleAskQuestion();
                                                        updatePipe("Ask A Question", e.auction_id);
                                                      } else {
                                                        typeof window !== "undefined" &&
                                                          localStorage.setItem(
                                                            "redirectUrl",
                                                            `/pipe/?pipeType=${pipeType
                                                              ?.map((ie) => ie)
                                                              .join(",")}&condition=${pipeCondition
                                                              ?.map((ew) => ew)
                                                              .join(",")}&make=${make
                                                              ?.map((wq) => wq)
                                                              .join(",")}&region=${region
                                                              ?.map((wq) => wq)
                                                              .join(",")}&saleType=${saleType
                                                              ?.map((wq) => wq)
                                                              .join(",")}&size=${pipeSize
                                                              ?.map((wq) => wq)
                                                              .join(",")}&material=${pipeMaterial
                                                              ?.map((wq) => wq)
                                                              .join(",")}&cerificate=${pipeMillCert
                                                              ?.map((wq) => wq)
                                                              .join(",")}`,
                                                          );
                                                        navigate("/members/login");
                                                      }
                                                    }}
                                                  >
                                                    Ask a Question
                                                  </td>
                                                  <td
                                                    class="ms-3 dark-green-text text-decoration-underline bid ask-question cursor-pointer"
                                                    onClick={() => {
                                                      const a =
                                                        e.pipe && e.pipe.sale_type === "Wanted Pipe (Sell Pipe)"
                                                          ? "Send a Quote"
                                                          : "Place a Bid";
                                                      updatePipe(a, e.auction_id);
                                                      if (isMobile) {
                                                        navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                                      } else {
                                                        navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                                      }
                                                    }}
                                                  >
                                                    {e.pipe && e.pipe.sale_type === "Wanted Pipe (Sell Pipe)"
                                                      ? "Send a Quote"
                                                      : "Place a Bid"}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </InfiniteScroll>
                                )}
                              </div>
                            </>
                          )}

                          {listings.filter((ls) => ls.end_date === "Surplus Inventory").length > 0 && (
                            <>
                              <div class="npcm-body mt-2">
                                <div
                                  class="npc-top d-md-flex align-items-md-center justify-content-md-between"
                                  style={{ borderTop: "2px solid white" }}
                                >
                                  <div className="npc-top-left">
                                    Surplus Negotiated Offers (
                                    {listings.filter((ls) => ls.end_date === "Surplus Inventory").length})
                                  </div>
                                </div>

                                {gridView ? (
                                  <ul class="new-product-list new-product-slider d-flex flex-wrap">
                                    {listings
                                      .filter((ls) => ls.end_date === "Surplus Inventory")
                                      .map((e) => (
                                        <li class="npl-item">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              updatePipe("Open Listing Details", e.auction_id);
                                              if (isMobile) {
                                                navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                              } else {
                                                navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                              }
                                            }}
                                          >
                                            <div class="npl-box">
                                              <div class="grid-img-box">
                                                <img src={e.image} alt={e.title} />
                                              </div>
                                              <div class="npl-content">
                                                <h4>{e.title}</h4>
                                                <p>{e.category}</p>
                                                <p class="grid-pick-intro">{e.quantity}</p>
                                                <small class="grid-location-desc">{e.location}</small>
                                                <h6>
                                                  Asking Price -{" "}
                                                  <strong>{e.asking_price ? "$" + e.asking_price : "N/A"}</strong>
                                                </h6>
                                              </div>
                                            </div>
                                          </a>
                                        </li>
                                      ))}
                                  </ul>
                                ) : (
                                  <InfiniteScroll
                                    initialLoad={false}
                                    pageStart={0}
                                    // loadMore={(e) => {
                                    //   if (listings?.filter((ls) => ls.end_date !== "Surplus Inventory")?.length > e) setCatPage(e);
                                    // }}
                                    hasMore={!loadingMain}
                                    useWindow={true}
                                    // loader={
                                    //   <div className="loader" key={0}>
                                    //     Loading ...
                                    //   </div>
                                    // }
                                  >
                                    <div class="table-responsive mb-30">
                                      <table class="product-list-table table table-bordered table-wrap pipe-table-fix pipe-table-fix-new">
                                        <thead class="table-light">
                                          <tr>
                                            <th>SR#</th>
                                            {/* {(tradingId === 2 || tradingId === 3) && <th>Ownership</th>} */}
                                            <th> Type</th>
                                            <th
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setSortBy("item");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                              colspan="2"
                                            >
                                              <span className="standard-font-page-title  ">Item </span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer"
                                              style={{ minWidth: "215px" }}
                                              onClick={() => {
                                                setSortBy("Price");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title "> Price</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer  "
                                              onClick={() => {
                                                setSortBy("MT");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">MT </span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>

                                            <th
                                              className="cursor-pointer  "
                                              onClick={() => {
                                                setSortBy("Length");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Length (feet)</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>

                                            <th
                                              className="cursor-pointer  "
                                              onClick={() => {
                                                setSortBy("Length");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">MTC</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer  "
                                              onClick={() => {
                                                setSortBy("Origin");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Mill/Origin</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer  "
                                              onClick={() => {
                                                setSortBy("Year");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Year</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>
                                            <th
                                              className="cursor-pointer  "
                                              onClick={() => {
                                                setSortBy("Location");
                                                if (sort === "asc") {
                                                  setSort("desc");
                                                } else {
                                                  setSort("asc");
                                                }
                                              }}
                                            >
                                              <span className="standard-font-page-title ">Location</span>{" "}
                                              <img class="table-th-icon" src={listCarretIcon} alt="listCarretIcon" />
                                            </th>

                                            <th>Question</th>
                                            <th>Pipe Trading</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {listings
                                            .filter((ls) => ls.end_date === "Surplus Inventory")
                                            .map((e, i) => {
                                              const filteredData =
                                                selectedItems && selectedItems.length > 0
                                                  ? selectedItems.filter((item) => item.auction_id === e.auction_id)[0]
                                                  : [];
                                              return (
                                                <tr>
                                                  <td>
                                                    <div>{i + 1}</div>
                                                  </td>
                                                  {/* {(tradingId === 2 || tradingId === 3) &&
                                                  !showLogo.includes(e.auction_id) && (
                                                    <td>
                                                      <div
                                                        class="accor-table-label text-capitalize yellow-bg bid hover-color yellow-show-owner"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() => {
                                                          updatePipe("Showed Owner of Listing", e.auction_id);
                                                          handleShowLogo(e);
                                                        }}
                                                      >
                                                        Show Owner
                                                      </div>
                                                    </td>
                                                  )}
                                                {(tradingId === 2 || tradingId === 3) &&
                                                  showLogo.includes(e.auction_id) && (
                                                    <td>
                                                      <div class="td-img-pipe-logo mfr-logo-width">
                                                        {filteredData.proc_logo ? (
                                                          <img
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                              setItem([
                                                                {
                                                                  original:
                                                                    process.env.GATSBY_MEDIA_URL +
                                                                    "/co/logos/" +
                                                                    filteredData.proc_logo,
                                                                },
                                                              ]);
                                                              toggleMfrModal();
                                                            }}
                                                            src={
                                                              process.env.GATSBY_MEDIA_URL +
                                                              "/co/logos/" +
                                                              filteredData.proc_logo
                                                            }
                                                            alt="proc_logo"
                                                          />
                                                        ) : (
                                                          <p
                                                            style={{
                                                              fontWeight: "600",
                                                            }}
                                                          >
                                                            {filteredData.name ? filteredData.name : "N/A"}
                                                          </p>
                                                        )}
                                                      </div>
                                                    </td>
                                                  )} */}

                                                  <td>
                                                    {e.pipe && e.pipe.sale_type === "Wanted Pipe (Sell Pipe)" ? (
                                                      <span
                                                        style={{
                                                          color: "#29c1f2",
                                                        }}
                                                      >
                                                        Wanted
                                                      </span>
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#227300",
                                                        }}
                                                      >
                                                        Auction Inventory
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td>
                                                    <div class="td-img">
                                                      <img src={e.image} alt={e.title} />
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <a
                                                      href={`/listings/listing_detail.cfm/aucid/${e.auction_id}`}
                                                      target="_blank"
                                                      onClick={() => updatePipe("Open Listing Details", e.auction_id)}
                                                    >
                                                      {e.title}
                                                    </a>
                                                  </td>
                                                  <td>
                                                    {e.asking_price > 0 ? (
                                                      <div class="grid7-offer d-flex flex-column align-items-start">
                                                        <div class="offer-label">Current Asking Price</div>
                                                        <div class="offer-total">
                                                          ${" "}
                                                          {parseInt(e.asking_price)
                                                            .toString()
                                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                        </div>
                                                        <div
                                                          class="offer-badge cursor-pointer"
                                                          onClick={(ed) => {
                                                            ed.preventDefault();
                                                            ed.stopPropagation();
                                                            if (isLoggedIn) {
                                                              navigate(
                                                                `/listings/listing_detail.cfm/aucid/${e.auction_id}`,
                                                                {
                                                                  state: { buyNowClicked: true },
                                                                },
                                                              );
                                                            } else {
                                                              typeof window !== "undefined" &&
                                                                localStorage.setItem(
                                                                  "redirectUrl",
                                                                  `/pipe/?pipeType=${pipeType
                                                                    ?.map((ie) => ie)
                                                                    .join(",")}&condition=${pipeCondition
                                                                    ?.map((ew) => ew)
                                                                    .join(",")}&make=${make
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&region=${region
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&saleType=${saleType
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&size=${pipeSize
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&material=${pipeMaterial
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}&cerificate=${pipeMillCert
                                                                    ?.map((wq) => wq)
                                                                    .join(",")}`,
                                                                );
                                                              navigate("/members/login");
                                                            }
                                                          }}
                                                        >
                                                          Buy Now or Counter Offer
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {e.wholesale_value > 0 ? (
                                                      <div class="grid7-highlighted-content w-100">
                                                        <div class="g-h-label">Wholesale Value</div>
                                                        <div class="g-h-total">
                                                          <span>
                                                            $
                                                            {parseInt(e.wholesale_value)
                                                              .toString()
                                                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </td>
                                                  <td>
                                                    {e.pipe &&
                                                      e.pipe.pipe_tonnage &&
                                                      parseFloat(e.pipe.pipe_tonnage)
                                                        .toFixed(2)
                                                        .toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                  </td>

                                                  <td>
                                                    {e.pipe &&
                                                      e.pipe.pipe_total_length &&
                                                      parseFloat(Math.trunc(e.pipe.pipe_total_length))
                                                        .toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                  </td>

                                                  <td>
                                                    {(e.pipe && e.pipe.pipe_mill_cert === "Yes") ||
                                                    (e.pipe && e.pipe.pipe_mill_cert === "true")
                                                      ? "Yes"
                                                      : (e.pipe && e.pipe.pipe_mill_cert === "No") ||
                                                        (e.pipe && e.pipe.pipe_mill_cert === "false")
                                                      ? "No"
                                                      : ""}
                                                  </td>
                                                  <td>
                                                    {e.pipe && e.pipe.pipe_origin_country
                                                      ? e.pipe.pipe_origin_country
                                                      : "N/A"}
                                                  </td>
                                                  <td>{e.pipe && e.pipe.pipe_year ? e.pipe.pipe_year : "N/A"}</td>
                                                  <td>{e.location ? e.location : "N/A"}</td>

                                                  <td
                                                    class="ms-3 dark-green-text text-decoration-underline bid ask-question cursor-pointer"
                                                    onClick={(p) => {
                                                      if (isLoggedIn) {
                                                        setAskQuestionItem(e);
                                                        toggleAskQuestion();
                                                        updatePipe("Ask A Question", e.auction_id);
                                                      } else {
                                                        typeof window !== "undefined" &&
                                                          localStorage.setItem(
                                                            "redirectUrl",
                                                            `/pipe/?pipeType=${pipeType
                                                              ?.map((ie) => ie)
                                                              .join(",")}&condition=${pipeCondition
                                                              ?.map((ew) => ew)
                                                              .join(",")}&make=${make
                                                              ?.map((wq) => wq)
                                                              .join(",")}&region=${region
                                                              ?.map((wq) => wq)
                                                              .join(",")}&saleType=${saleType
                                                              ?.map((wq) => wq)
                                                              .join(",")}&size=${pipeSize
                                                              ?.map((wq) => wq)
                                                              .join(",")}&material=${pipeMaterial
                                                              ?.map((wq) => wq)
                                                              .join(",")}&cerificate=${pipeMillCert
                                                              ?.map((wq) => wq)
                                                              .join(",")}`,
                                                          );
                                                        navigate("/members/login");
                                                      }
                                                    }}
                                                  >
                                                    Ask a Question
                                                  </td>
                                                  <td
                                                    class="ms-3 dark-green-text text-decoration-underline bid ask-question cursor-pointer"
                                                    onClick={() => {
                                                      const a =
                                                        e.pipe && e.pipe.sale_type === "Wanted Pipe (Sell Pipe)"
                                                          ? "Send a Quote"
                                                          : "Place a Bid";
                                                      updatePipe(a, e.auction_id);
                                                      if (isMobile) {
                                                        navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                                      } else {
                                                        navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                                      }
                                                    }}
                                                  >
                                                    {e.pipe && e.pipe.sale_type === "Wanted Pipe (Sell Pipe)"
                                                      ? "Send a Quote"
                                                      : "Place a Bid"}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </InfiniteScroll>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <div class="empty-block-container text-center empty-block-container-pipe">
                          <div class="empty-block-icon">
                            <img src={emptyIcon} alt="empty List" />
                          </div>
                          <h4>No Listings Found!</h4>
                          <p>Et faucibus at aliquet est nisi, justo, varius libero, erat..</p>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          <Footer />
        </div>
        {!loadingMain && (
          <div class="mob-filter-btn-group d-lg-none d-flex align-items-center">
            <a
              href="javascript:void(0)"
              class="filter-btn d-flex align-items-center justify-content-center"
              data-bs-toggle="modal"
              data-bs-target="#pipeCollapse"
              onClick={() => setShowFilterMobileModal(true)}
            >
              <p>Filters {filterCount > 0 && <span>({filterCount})</span>}</p>
            </a>
          </div>
        )}
        <AskQuestionModal show={showAskQuestion} handleClose={toggleAskQuestion} product={askquestionItem} />
        <ImageLargeModal
          show={showMfrModal}
          handleClose={toggleMfrModal}
          items={item}
          startIndex={0}
          fullScreen={"yes"}
        />
        <PipeFilterSidebarMobile
          showModal={showFilterMobileModal}
          toggleModal={() => setShowFilterMobileModal(!showFilterMobileModal)}
          clearFilter={(val) => clearFilter(val)}
          removeFilter={removeFilter}
          toggleFilter={() => setShowFilterModal(!showFilterModal)}
          filterModalData={(data) => setFilterModalData(data)}
          filterModalDataCounts={(count) => setFilterModalDataCounts(count)}
          modalType={(t) => setModalType(t)}
          facets={facets}
          setData={setData}
          saleType={saleType}
          pipeType={pipeType}
          pipeCondition={pipeCondition}
          pipeMillCert={pipeMillCert}
          pipeSize={pipeSize}
          pipeMaterial={pipeMaterial}
          catagory={catagory}
          catagory1={catagory1}
          make={make}
          model={model}
          region={region}
        />
      </>
      {/* )} */}
    </>
  );
};
export default App;

export const Head = ({ location, pageContext }) => (
  <SEO
    canonical={`https://www.salvex.com${location.pathname}`}
    title="OCTG, Line Pipe, Drill Pipe For Sale (Surplus, Used, Structural, and Scrap) | Salvex"
    description="Salvex assists Oil and Gas Companies globally to sell their surplus, structural and scrap OCTG (Casing & Tubing), Line Pipe, Drill Pipe and other surplus assets."
  />
);
